import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { withTranslation } from 'react-i18next';
import PhoneField from 'components/v2/forms/PhoneField';
import FormCard from '../../v2/FormCard';
import UserActionCreators from '../../../actions/UserActionCreators';

const getEmptyState = () => {
  return {
    vendor: {
      company_name: '',
      email: '',
      first_name: '',
      last_name: '',
      password: '',
      phone: '',
    },
  };
};

class RegisterVendor extends Component {
  constructor(props) {
    super(props);
    this.state = getEmptyState();
  }

  handlePhoneChange = (phone) => {
    this.setState((prevState) => {
      return {
        vendor: {
          ...prevState.vendor,
          phone,
        },
      };
    });
  };

  handleChange = (field) => (e) => {
    const {
      target: { value },
    } = e;
    this.setState((prevState) => {
      return {
        vendor: {
          ...prevState.vendor,
          [field]: value,
        },
      };
    });
  };

  handleRegister = (e) => {
    e.preventDefault();
    const { vendor } = this.state;
    UserActionCreators.addVendor({
      ...vendor,
    });
    this.setState(getEmptyState());
  };

  render() {
    const { vendor } = this.state;
    const { t } = this.props;
    const disabled =
      isEmpty(vendor.company_name) ||
      isEmpty(vendor.email) ||
      isEmpty(vendor.first_name) ||
      isEmpty(vendor.last_name) ||
      isEmpty(vendor.password) ||
      isEmpty(vendor.phone);

    return (
      <FormCard
        actions={() => (
          <button
            disabled={disabled}
            className="button button-green"
            type="submit"
            onClick={this.handleRegister}
          >
            {t('REGISTER_VENDOR')}
          </button>
        )}
      >
        <div className="mb-4">
          <h3 className="text-lg font-medium text-gray-900 leading-6">
            {t('VENDOR_PROFILE')}
          </h3>
        </div>
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('FIRST_NAME')}</label>
            <input
              className="w-full mb-4 form-field"
              type="text"
              placeholder="John"
              onChange={this.handleChange('first_name')}
              value={vendor.first_name}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('LAST_NAME')}</label>
            <input
              className="w-full mb-4 form-field"
              type="text"
              placeholder="Smith"
              onChange={this.handleChange('last_name')}
              value={vendor.last_name}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">
              <span>{t('COMPANY_NAME')}</span>
            </label>
            <input
              className="w-full mb-4 form-field"
              type="text"
              placeholder={t('COMPANY_NAME')}
              onChange={this.handleChange('company_name')}
              value={vendor.company_name}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('PHONE')}</label>
            <PhoneField
              id="vendor-phone"
              onChange={this.handlePhoneChange}
              value={vendor.phone}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('EMAIL')}</label>
            <input
              className="w-full mb-4 form-field"
              type="email"
              placeholder="example@cargomatic.com"
              onChange={this.handleChange('email')}
              value={vendor.email}
            />
          </div>
          <div className="col-span-4 sm:col-span-2">
            <label className="block mb-2 form-label">{t('PASSWORD')}</label>
            <input
              className="w-full mb-4 form-field"
              type="password"
              placeholder={t('PASSWORD')}
              onChange={this.handleChange('password')}
              value={vendor.password}
            />
          </div>
        </div>
      </FormCard>
    );
  }
}

export default withTranslation()(RegisterVendor);
